/* eslint-disable */
import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_API + "/excursion/bus-company-prices/";


const state = {
    busCompaniesPrices: []
}

const actions = {
    async retrieveBusCompaniesPrices({
        commit,
        dispatch
    }, payload) {
        // retrieve bus companies prices list (grouped by company) from bus application database        
        return axios
            .get(
                baseUrl
            )
            .then(response => {
                commit('SET_BUS_COMPANIES_PRICES', response.data)
                return response.data
            })
    },
    async createBusCompanyPrice({
        commit, dispatch
    }, payload) {
        // check whether price has "," instead of "." and in this case, replace
        if ( payload.payload.price.includes(",") ) {
            payload.payload.price = payload.payload.price.replace(',', '.')
        }
        await axios
            .post(baseUrl, payload.payload)
            .then( response => {
                dispatch('retrieveBusCompaniesPrices')
                return response.data
            })
            .catch( error => {
                this._vm.$notify({
                    group: "foo",
                    title: "Compañía de bus NO guardada",
                    text: error + ' ' + JSON.stringify(error.response.data),
                    type: "error",
                });
                throw new Error(error) 
            })
    },
    async updateBusCompanyPrice({
        commit, dispatch
    }, payload) {
        // check whether price has "," instead of "." and in this case, replace
        if ( payload.payload.price.includes(",") ) {
            payload.payload.price = payload.payload.price.replace(',', '.')
        }
        await axios
            .patch(baseUrl + payload.item_id + '/', payload.payload)
            .then( response =>  {
                dispatch('retrieveBusCompaniesPrices')
                return response.data
            })
            .catch( error => {
                this._vm.$notify({
                    group: "foo",
                    title: "Compañía de bus NO guardada",
                    text: error + ' ' + JSON.stringify(error.response.data),
                    type: "error",
                });
                throw new Error(error) 
            })
    },
    async deleteBusCompanyPrice({
        commit, dispatch
    }, payload) {
        return axios.delete(baseUrl + payload.item_id + '/')
    }
}

const mutations = {
    SET_BUS_COMPANIES_PRICES(state, bus_companies_prices) {
        state.busCompaniesPrices = bus_companies_prices
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}